import React from "react";

const BALogo = ({ customClassName, primaryColor, height, width }) => {
    let pColor = "#00bfa5";
    let h = "35px";
    let w = "35px";


    if (primaryColor !== undefined) {
        pColor = primaryColor;
    }

    if (height !== undefined) {
        h = height;
    }

    if (width !== undefined) {
        w = width;
    }

    return <div className={customClassName}>
        <svg xmlns="http://www.w3.org/2000/svg" height={h} width={w} viewBox="0 0 43.17 43.17">
            <g>
                <path fill={pColor} d="M26.63,16.54A7.13,7.13,0,0,0,16.54,26.63h0A7.13,7.13,0,1,0,26.63,16.54Zm0,0A7.13,7.13,0,0,0,16.54,26.63h0A7.13,7.13,0,1,0,26.63,16.54ZM21.58,0A21.58,21.58,0,1,0,43.17,21.58,21.58,21.58,0,0,0,21.58,0ZM38.66,27.81a1.83,1.83,0,0,1-1.3-.53l-5-5a10.79,10.79,0,0,1-18.33,7L14,29.21,3.22,18.48A1.83,1.83,0,0,1,5.8,15.89l5,5a10.79,10.79,0,0,1,18.33-7l.07.06L40,24.69a1.83,1.83,0,0,1-1.29,3.12ZM21.58,14.45a7.14,7.14,0,0,0-5,12.18h0a7.13,7.13,0,1,0,5-12.18Zm5,2.09A7.13,7.13,0,0,0,16.54,26.63h0A7.13,7.13,0,1,0,26.63,16.54Z" />
            </g>
        </svg>
    </div>
};

export default BALogo;